module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_03_beach-photo-f1cffb464975da7624a6ed80d81b059b.jpg";